<template>
<div>

    <v-layout row wrap>
        <v-flex s12>
            <v-autocomplete v-model="paisSelected" :items="paises" :hide-no-data="true" :hide-selected="true" clearable :item-text="nombrePais" item-value="id_pais" label="Selecciona un País" @input="cargarEstados(1)" :rules="option_required>=1?[rules.required]:[]"></v-autocomplete>
        </v-flex>
        <v-flex s12 v-if="option_combos>1">
            <v-autocomplete v-model="estadoSelected" :items="estados" :hide-no-data="true" :hide-selected="true" clearable :item-text="nombreEstado" item-value="id_estado" label="Selecciona un Estado" @input="cargarCiudadesMunicipios(1)" :loading="loadingEstado"></v-autocomplete>
        </v-flex>
        <v-flex s12 v-if="option_combos==3 || option_combos==5">
            <v-autocomplete v-model="ciudadSelected" :items="ciudades" :hide-no-data="true" :hide-selected="true" clearable :item-text="nombreCiudad" item-value="descripcion" label="Selecciona una Ciudad" :loading="loadingCiudad"></v-autocomplete>
        </v-flex>
        <v-flex s12 v-if="option_combos>4">
            <v-autocomplete v-model="municipioSelected" :items="municipios" :hide-no-data="true" :hide-selected="true" clearable :item-text="nombreMunicipio" item-value="descripcion" label="Selecciona un Municipio" :loading="loadingMunicipio"></v-autocomplete>
        </v-flex>
    </v-layout>

</div>
</template>

<script>
import axios from "axios";

export default {
    props: {
        onSelectPais: Function, // eslint-disable-line
        onSelectEstado: Function, // eslint-disable-line
        onSelectCiudad: Function, // eslint-disable-line
        onSelectMunicipio: Function, // eslint-disable-line
        param_pais: {type: String,default: ''},
        param_estado: {type: String,default: ''},
        param_ciudad: {type: String,default: ''},
        param_municipio: {type: String,default: ''},
        option_combos: {type: Number,default: 0}, //1-Pais, 2-Pais,Estado, 3-Pais,Estado,Ciudad, 4-Pais,Estado,Municipio, 5-Pais,Estado,Ciudad,Municipio
        option_required: {type: Number,default: 1}, //1-Pais, 2-Pais,Estado, 3-Pais,Estado,Ciudad, 4-Pais,Estado,Municipio, 5-Pais,Estado,Ciudad,Municipio

    },
    data() {
        return {
            fab: false,
            name: "ComboPaises",
            loading: false,
            paises: [],
            estados: [],
            ciudades: [],
            municipios: [],
            pais: '',
            estado: '',
            ciudad: '',
            municipio: '',
            rules: {
                required: v => !!v || "Este campo es requerido"
            },
            loadingEstado: false,
            loadingCiudad: false,
            loadingMunicipio: false,
        };
    },
    computed: {
        paisSelected: {
            get: function () {
                return this.param_pais;
            },
            set: function (newValue) {
                this.pais = newValue;
            }
        },
        estadoSelected: {
            get: function () {
                return this.param_estado;
            },
            set: function (newValue) {
                this.estado = newValue;
            }
        },
        ciudadSelected: {
            get: function () {
                return this.param_ciudad;
            },
            set: function (newValue) {
                this.ciudad = newValue;
            }
        },
        municipioSelected: {
            get: function () {
                return this.param_municipio;
            },
            set: function (newValue) {
                this.municipio = newValue;
            }
        }
    },
    watch: {
        param_pais: function (newV, oldV) {
            if (newV == null || newV == undefined)
                this.pais = '';
            else
                this.pais = newV;            
        },
        param_estado: function (newV, oldV) {
            if (newV == null || newV == undefined)
                this.estado = '';
            else
                this.estado = newV;            
        },
        pais: function (newV, oldV) {
            if (newV == null || newV == undefined)
                this.onSelectPais && this.onSelectPais('');
            else
                this.onSelectPais && this.onSelectPais(newV);
            this.estados = [];
            this.ciudades = [];
            this.municipios = [];
            this.cargarEstados(2);            
        },
        estado: function (newV, oldV) {
            if (newV == null || newV == undefined)
                this.onSelectEstado && this.onSelectEstado('');
            else
                this.onSelectEstado && this.onSelectEstado(newV);
            this.ciudades = [];
            this.municipios = [];
            this.cargarCiudadesMunicipios(2);
        },
        ciudad: function (newV, oldV) {
            if (newV == null || newV == undefined)
                this.onSelectCiudad && this.onSelectCiudad('');
            else
                this.onSelectCiudad && this.onSelectCiudad(newV);
        },
        municipio: function (newV, oldV) {
            if (newV == null || newV == undefined)
                this.onSelectMunicipio && this.onSelectMunicipio('');
            else
                this.onSelectMunicipio && this.onSelectMunicipio(newV);
        },
    },
    created: function () {
        this.cargarPaises();
    },
    methods: {
        nombrePais: function (pais) {
            return (pais != undefined) ? pais.clave_m3 + " - " + pais.nombre : '';
        },
        nombreEstado: function (estado) {
            return (estado != undefined) ? estado.clave + " - " + estado.nombre : '';
        },
        nombreCiudad: function (ciudad) {
            return (ciudad != undefined) ? ciudad.clave + " - " + ciudad.descripcion : '';
        },
        nombreMunicipio: function (municipio) {
            return (municipio != undefined) ? municipio.clave + " - " + municipio.descripcion : '';
        },
        cargarPaises: function () {
            axios
                .get(this.$hostname + "paises/")
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.paises = res.data;                        
                        if (this.param_pais != "")
                            this.cargarEstados(2);
                    } else {
                        this.$swal({
                            type: "warning",
                            title: "Aviso",
                            text: "No se han ingresado datos al catálogo de países",
                            footer: ""
                        });
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el catálogo de países.",
                        footer: ""
                    });
                    console.log(err);
                });
        },

        cargarEstados: function (opcion) {
            if (opcion == 1) {
                //1-Limpiar estado seleccionado, 2-No limpiar
                this.estadoSelected = "";
                this.ciudadSelected = "";
                this.municipioSelected = "";
            }
            var id_pais = "";            
            if (this.pais != null && this.pais != '') {                
                id_pais = this.pais; 
            }else if (this.param_pais != null && this.param_pais != '') {                
                id_pais = this.param_pais; 
            }

            if (id_pais != ""){
                this.loadingEstado = true;
                axios
                    .post(this.$hostname + "estados/get_estados_pais/", {
                        pais: id_pais
                    })
                    .then(res => { 
                        if (typeof res.data !== "undefined") {
                            this.estados = res.data;
                            if (this.param_estado != "")
                                this.cargarCiudadesMunicipios(2);
                        }
                    })
                    .catch(err => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al obtener los estados asociados al país seleccionado.",
                            footer: ""
                        });
                        console.log(err);
                    }).then(() => {
                        this.loadingEstado = false;
                    });
            }
        },

        cargarCiudadesMunicipios: function (opcion) {
            if (opcion == 1) {
                //1-Limpiar ciudad,municipio seleccionado, 2-No limpiar
                this.ciudadSelected = "";
                this.municipioSelected = "";
            }
            var id_pais = "";
            var id_estado = "";

            if (this.pais != null && this.pais != '') {
                id_pais = this.pais;
            } else if (this.param_pais != null && this.param_pais != '') {                                
                id_pais = this.param_pais;
            }
            if (this.estado != null && this.estado != '') {                
                id_estado = this.estado;                
            } else if (this.param_estado != null && this.param_estado != '') {                
                id_estado = this.param_estado;                
            }

            if (id_pais !="" && id_estado!="") {
                this.loadingCiudad = true;
                axios
                    .post(this.$hostname + "catalogos/ciudades/get_ciudades/", {
                        pais: id_pais,
                        estado: id_estado
                    })
                    .then(res => {
                        if (typeof res.data !== "undefined") {
                            this.ciudades = res.data;
                        }
                    })
                    .catch(err => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al obtener las ciudades asociados al estado seleccionado.",
                        });
                        console.log(err);
                    }).then(() => {
                        this.loadingCiudad = false;
                        this.cargarMunicipios();
                    });
            }
        },

        cargarMunicipios: function () {            
            var id_pais = "";
            var id_estado = "";

            if (this.pais != null && this.pais != '') {                                
                id_pais = this.pais;
            } else if (this.param_pais != null && this.param_pais != '') {                                
                id_pais = this.param_pais;
            }
            if (this.estado != null && this.estado != '') {                
                id_estado = this.estado;                
            } else if (this.param_estado != null && this.param_estado != '') {                
                id_estado = this.param_estado;                
            }
            
            if (id_pais!="" && id_estado!=""){
                this.loadingMunicipio = true;
                axios
                    .post(this.$hostname + "catalogos/municipios/get_municipios/", {
                        pais: id_pais,
                        estado: id_estado
                    })
                    .then(res => {
                        if (typeof res.data !== "undefined") {
                            this.municipios = res.data;
                        }
                    })
                    .catch(err => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al obtener los municipios asociados al estado seleccionado.",
                        });
                        console.log(err);
                    }).then(() => {
                        this.loadingMunicipio = false;
                    });
            }

        },

    }
};
</script>
